// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the moanokea's stocks open at,
// NOAA's density of the fish the fishery takes and its catch (Nadon 2017), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/moanokea.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const MOANOKEA_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 3.523,
  fishingPerYear: 0.0577827,
  restSpawnersKg: 33125.7,
  predatorOtherPreyKg: { ulua: [924174, 1192770, 497613, 71255.2], omilu: [448670, 580681, 241130, 34492.9] },
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const MOANOKEA_JANUARY: FishJanuary = {
  islands: [
    [8920.74, 8221.93, 6739.74, 4206.16, 3067.77, 2582.18, 2048.33, 2001.98, 1363.6, 929.778, 653.586, 589.622, 630.946, 578.831, 472.519, 294.071, 214.254, 180.293, 143.011, 139.772, 95.2024, 64.9141, 45.6313, 41.1655, 44.0506, 40.4122, 32.9898, 20.5311, 14.9585, 12.5875, 9.98455, 9.75847, 6.64673, 4.5321, 3.18583, 2.87404, 3.07548, 2.82145, 2.30324, 1.43341, 1.04436, 0.878818, 0.697089, 0.681304, 0.464052, 0.316416, 0.222424, 0.200657, 0.214721, 0.196985, 0.160805, 0.100077, 0.0729138, 0.0613564, 0.0486687, 0.0475667, 0.0323988, 0.0220912, 0.0155289, 0.014009, 0.0149909, 0.0137527, 0.0112268, 0.00698693, 0.00509054, 0.0220416],
    [6135.8, 4708.28, 3739.73, 2529.87, 2019.51, 1899.3, 1806.15, 1384.37, 1065.02, 937.036, 688.287, 616.853, 433.973, 331.467, 262.19, 176.874, 141.043, 132.613, 126.102, 96.6527, 74.3561, 65.4208, 48.054, 43.0667, 30.2985, 23.1419, 18.3052, 12.3488, 9.8472, 9.2586, 8.80403, 6.74797, 5.1913, 4.56747, 3.35497, 3.00678, 2.11535, 1.61569, 1.27801, 0.862152, 0.687499, 0.646405, 0.614668, 0.471121, 0.362439, 0.318885, 0.234233, 0.209924, 0.147687, 0.112803, 0.089227, 0.0601928, 0.0479991, 0.0451301, 0.0429143, 0.0328923, 0.0253045, 0.0222637, 0.0163534, 0.014656, 0.0103109, 0.00787543, 0.00622946, 0.00420242, 0.0033511, 0.0173743],
    [8178.46, 6742.02, 5008.96, 3591.17, 3144.02, 2387.7, 2190.28, 2023.89, 1556.47, 1364.52, 975.165, 786.053, 578.445, 474.643, 351.174, 251.074, 219.579, 166.714, 152.921, 141.302, 108.667, 95.2663, 68.0828, 54.8796, 40.3851, 33.138, 24.5178, 17.5291, 15.3303, 11.6394, 10.6764, 9.86523, 7.5868, 6.65117, 4.75331, 3.83151, 2.81955, 2.31359, 1.71175, 1.22383, 1.07031, 0.812623, 0.745393, 0.688756, 0.529684, 0.464362, 0.331861, 0.267505, 0.196853, 0.161527, 0.119509, 0.0854436, 0.0747256, 0.0567348, 0.052041, 0.0480868, 0.0369809, 0.0324203, 0.0231693, 0.018676, 0.0137434, 0.0112771, 0.0083436, 0.0059653, 0.00521702, 0.0234668],
    [4729.37, 4291.9, 3460.82, 2051.01, 1507.38, 1194.47, 1095, 1156.6, 769.409, 409.516, 355.198, 391.345, 334.499, 302.154, 242.636, 143.395, 105.276, 83.4003, 76.4505, 80.7506, 53.7178, 28.5911, 24.7988, 27.3224, 23.3536, 21.0954, 16.9401, 10.0114, 7.35004, 5.82274, 5.33753, 5.63775, 3.7504, 1.99614, 1.73137, 1.90757, 1.63048, 1.47281, 1.1827, 0.698961, 0.513156, 0.406525, 0.372649, 0.393609, 0.261841, 0.139364, 0.120879, 0.133181, 0.113835, 0.102828, 0.0825727, 0.0487994, 0.035827, 0.0283824, 0.0260172, 0.0274806, 0.0182809, 0.00972998, 0.00843933, 0.0092981, 0.00794747, 0.00717898, 0.00576487, 0.00340697, 0.00250129, 0.0115908],
  ],
  afloat: [
    [281.488, 230.771, 281.691, 160.776],
    [281.506, 230.79, 281.713, 160.787],
    [281.524, 230.809, 281.735, 160.798],
    [281.542, 230.827, 281.757, 160.809],
    [281.559, 230.846, 281.779, 160.82],
    [281.577, 230.865, 281.801, 160.83],
    [281.595, 230.883, 281.822, 160.841],
    [281.612, 230.901, 281.844, 160.852],
    [281.63, 230.92, 281.865, 160.863],
    [281.647, 230.938, 281.886, 160.873],
    [281.665, 230.956, 281.907, 160.884],
    [281.682, 230.973, 281.928, 160.894],
    [281.699, 230.991, 281.948, 160.904],
    [281.716, 231.008, 281.969, 160.915],
    [206.354, 262.844, 344.085, 156.178],
    [206.367, 262.865, 344.112, 156.189],
    [206.38, 262.885, 344.139, 156.199],
    [206.394, 262.905, 344.166, 156.21],
    [206.407, 262.925, 344.193, 156.22],
    [206.42, 262.945, 344.219, 156.231],
    [206.433, 262.964, 344.245, 156.241],
    [206.446, 262.984, 344.271, 156.251],
    [206.459, 263.003, 344.297, 156.261],
    [206.471, 263.022, 344.323, 156.271],
    [206.484, 263.041, 344.348, 156.281],
    [206.496, 263.06, 344.373, 156.29],
    [206.509, 263.078, 344.398, 156.3],
    [206.521, 263.097, 344.422, 156.31],
    [206.533, 263.115, 344.446, 156.319],
    [205.798, 262.05, 343.008, 155.749],
    [205.81, 262.068, 343.032, 155.758],
    [205.822, 262.086, 343.055, 155.768],
    [205.833, 262.103, 343.078, 155.777],
    [205.845, 262.12, 343.101, 155.786],
    [205.856, 262.137, 343.123, 155.794],
    [205.867, 262.154, 343.145, 155.803],
    [205.878, 262.17, 343.167, 155.812],
    [205.889, 262.186, 343.189, 155.82],
    [205.9, 262.202, 343.21, 155.828],
    [205.91, 262.218, 343.23, 155.836],
    [205.921, 262.233, 343.251, 155.844],
    [205.931, 262.248, 343.271, 155.852],
    [205.941, 262.263, 343.291, 155.86],
    [205.95, 262.277, 343.31, 155.868],
    [205.96, 262.292, 343.329, 155.875],
  ],
};
